module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGUlEQVR4nGNITAj6TwlmGDVg1IBRA4aLAQDtDRIfwY6xMAAAAABJRU5ErkJggg=="